export default {
  ADD_CORRESPONDENCIAS(state, correspondencias) {
    state.correspondencias = [...state.correspondencias, ...correspondencias]
  },
  SET_CORRESPONDENCIAS(state, correspondencias) {
    state.correspondencias = correspondencias
  },
  ADD_EVENTOS(state, eventos) {
    state.eventos = [...state.eventos, ...eventos]
  },
  SET_EVENTOS(state, eventos) {
    state.eventos = eventos
  },
}
